import React, { Component } from 'react';
import * as Styles from './Styles';
import Button from '../../../../../components/button/Button';
import { JSXLike } from '../../../../../models/Global';
import HoverPopover, { POSITION } from '@react_components/hover_popover';

type Props = {
	extendedContent: JSXLike;
	contentTop: JSXLike;
	contentBottom?: JSXLike;
	heading: JSXLike;
	error?: string | null;
};

type State = {
	extended: boolean;
};

class Pocket extends Component<Props, State> {
	state: State = {
		extended: false,
	};

	render() {
		return (
			<Styles.Wrapper>
				<Styles.MainContentContainer>
					{this.props.error && (
						<HoverPopover
							content={<span>{this.props.error}</span>}
							position={POSITION.TOP}
						>
							<Styles.StyledSvgInfo />
						</HoverPopover>
					)}
					<Styles.HeadingContainer>
						{this.props.heading}
					</Styles.HeadingContainer>
					<Styles.ContentSocket>
						{this.props.contentTop}
					</Styles.ContentSocket>
					{this.props.contentBottom && (
						<Styles.ContentSocket>
							{this.props.contentBottom}
						</Styles.ContentSocket>
					)}
				</Styles.MainContentContainer>
				<Styles.AdditionalContentContainer>
					<Styles.ButtonContainer>
						<Styles.ButtonRail extended={this.state.extended} />
						<Button
							Icon={
								<Styles.ButtonIcon
									extended={this.state.extended}
								/>
							}
							label="co obejmuje ubezpieczenie?"
							onClick={() =>
								this.setState({
									...this.state,
									extended: !this.state.extended,
								})
							}
							style={Styles.getButtonStyle(this.state.extended)}
						/>
						<Styles.ButtonRail extended={this.state.extended} />
					</Styles.ButtonContainer>
					<Styles.ExtendedContentContainer
						extended={this.state.extended}
					>
						{this.props.extendedContent}
					</Styles.ExtendedContentContainer>
				</Styles.AdditionalContentContainer>
			</Styles.Wrapper>
		);
	}
}

export default Pocket;
